import { EventEmitter, Component, forwardRef, Input, Output, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc2 from '@angular/common';

const _c0 = function (a0) { return { "fa-check": a0 }; };
function MultiselectComponent_li_13_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵtext(1, "\n                ");
    ɵngcc0.ɵɵelementStart(2, "a", 8);
    ɵngcc0.ɵɵlistener("click", function MultiselectComponent_li_13_Template_a_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r5); const i_r3 = ctx.index; const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.itemSelected(i_r3); });
    ɵngcc0.ɵɵtext(3, " ");
    ɵngcc0.ɵɵelement(4, "i", 9);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n            ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c0, item_r2.Selected));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r0.getItemText(item_r2), " ");
} }
function MultiselectComponent_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelementStart(2, "li", 10);
    ɵngcc0.ɵɵtext(3, "\n                ");
    ɵngcc0.ɵɵelementStart(4, "a", 11);
    ɵngcc0.ɵɵlistener("click", function MultiselectComponent_ng_container_16_Template_a_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.selectAll(true); });
    ɵngcc0.ɵɵtext(5, " select all ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(7, "\n            ");
    ɵngcc0.ɵɵelementStart(8, "li");
    ɵngcc0.ɵɵtext(9, "\n                ");
    ɵngcc0.ɵɵelementStart(10, "a", 11);
    ɵngcc0.ɵɵlistener("click", function MultiselectComponent_ng_container_16_Template_a_click_10_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.selectAll(false); });
    ɵngcc0.ɵɵtext(11, " deselect all ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(12, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(13, "\n        ");
    ɵngcc0.ɵɵelementContainerEnd();
} }
class MultiselectItem {
    constructor(Item, Selected) {
        this.Item = Item;
        this.Selected = Selected;
    }
}

class MultiselectComponent {
    constructor() {
        this.valueIdAccessor = 'Id';
        this.showSelectAllButtons = true;
        this.filterMode = true;
        this.disabled = false;
        this.blur = new EventEmitter();
        this.focus = new EventEmitter();
        this.selectionChanged = new EventEmitter();
        this.hasFocus = false;
    }
    // *** CONTROL VALUE ACCESSOR ***
    /* tslint:disable:member-ordering */
    writeValue(obj) {
        this.handleWriteValue(obj);
    }
    registerOnChange(fn) {
        this.onValueChanged = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    ngOnInit() {
        if (!this.placeholder) {
            this.placeholder = this.entity ? `no ${this.entity} selected` : 'nothing selected';
        }
        if (this.maxToShowInSelectedText === undefined) {
            this.maxToShowInSelectedText = 3;
        }
        if (this.autoClose === undefined) {
            this.autoClose = 'outside';
        }
    }
    ngOnDestroy() {
        if (this.hasFocus) {
            this.blur.emit();
        }
    }
    get allSelected() {
        return this.items.every((item) => item.Selected);
    }
    get noneSelected() {
        return this.items.every((item) => !item.Selected);
    }
    get countOfSelected() {
        return this.items.filter((item) => item.Selected).length;
    }
    get selectedItems() {
        return [...this.items.filter((item) => item.Selected).map((item) => item.Item)];
    }
    selectedItemsText() {
        if (this.filterMode) {
            if (this.allSelected) {
                return `Any ${this.entity}`;
            }
            if (this.noneSelected) {
                return `${this.entity}`;
            }
        }
        else {
            if (this.noneSelected) {
                return `<em>${this.placeholder}</em>`;
            }
        }
        if (!this.maxToShowInSelectedText || this.countOfSelected <= this.maxToShowInSelectedText) {
            return this.items
                .filter((item) => item.Selected)
                .map((item) => this.getItemText(item))
                .join(', ');
        }
        let returnText = this.items
            .filter((item) => item.Selected)
            .slice(0, this.maxToShowInSelectedText)
            .map((item) => this.getItemText(item))
            .join(', ');
        return `${returnText} +${this.countOfSelected - this.maxToShowInSelectedText} more`;
    }
    getItemText(item) {
        return item && item.Item ? item.Item.Name : '';
    }
    itemSelected(index) {
        const selectedItem = this.items[index];
        selectedItem.Selected = !selectedItem.Selected;
        this.emitSelectionChangedEvent();
    }
    selectAll(checkAll) {
        this.items.forEach((item) => {
            item.Selected = checkAll;
        });
        this.emitSelectionChangedEvent();
    }
    emitSelectionChangedEvent() {
        const event = {
            items: [...this.items],
            selectedItems: this.selectedItems,
        };
        this.selectionChanged.emit(event);
        this.updateValue();
    }
    updateValue() {
        if (!this.onValueChanged) {
            return;
        }
        let value = this.selectedItems;
        if ((value === null || value === void 0 ? void 0 : value.length) && this.valueIdAccessor && value[0][this.valueIdAccessor]) {
            value = value.map((item) => item[this.valueIdAccessor]);
        }
        value = (value === null || value === void 0 ? void 0 : value.length) ? value : null; // set to null if no values in array
        this.onValueChanged(value);
    }
    handleWriteValue(value) {
        this.items.forEach((item) => {
            if (!(value === null || value === void 0 ? void 0 : value.length)) {
                item.Selected = false;
            }
            else if (this.valueIdAccessor) {
                item.Selected = value.some((id) => item.Item[this.valueIdAccessor] === id);
            }
            else {
                item.Selected = value.some((valueItem) => JSON.stringify(item.Item) === JSON.stringify(valueItem));
            }
        });
    }
    openChange(dropdownOpen) {
        var _a;
        if (dropdownOpen) {
            this.hasFocus = true;
            this.focus.emit();
        }
        else {
            this.hasFocus = false;
            this.blur.emit();
        }
        (_a = this.onTouched) === null || _a === void 0 ? void 0 : _a.call(this);
    }
}
MultiselectComponent.ɵfac = function MultiselectComponent_Factory(t) { return new (t || MultiselectComponent)(); };
MultiselectComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MultiselectComponent, selectors: [["multiselect"]], inputs: { valueIdAccessor: "valueIdAccessor", showSelectAllButtons: "showSelectAllButtons", filterMode: "filterMode", disabled: "disabled", placeholder: "placeholder", maxToShowInSelectedText: "maxToShowInSelectedText", autoClose: "autoClose", items: "items", entity: "entity" }, outputs: { blur: "blur", focus: "focus", selectionChanged: "onSelectionChanged" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                multi: true,
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => MultiselectComponent)
            },
        ])], decls: 20, vars: 11, consts: [["ngbDropdown", "", 1, "dropdown", 3, "autoClose", "openChange"], ["ngbDropdownToggle", "", "type", "button", 1, "btn", "dropdown-toggle", 3, "tabindex", "disabled"], [3, "innerHtml"], [1, "caret"], ["ngbDropdownMenu", "", "aria-labelledby", "statusDropDown", 1, "dropdown-menu"], [1, "scrollable-menu"], [4, "ngFor", "ngForOf"], [4, "ngIf"], [3, "click"], [1, "fa", "fa-fw", 3, "ngClass"], [1, "select-all-separator"], [1, "btn", "btn-xs", "btn-default", "btn-flat", "select-all-button", 3, "click"]], template: function MultiselectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "span", 0);
        ɵngcc0.ɵɵlistener("openChange", function MultiselectComponent_Template_span_openChange_0_listener($event) { return ctx.openChange($event); });
        ɵngcc0.ɵɵtext(1, "\n    ");
        ɵngcc0.ɵɵelementStart(2, "button", 1);
        ɵngcc0.ɵɵtext(3, "\n        ");
        ɵngcc0.ɵɵelement(4, "span", 2);
        ɵngcc0.ɵɵtext(5, "\n        ");
        ɵngcc0.ɵɵelement(6, "span", 3);
        ɵngcc0.ɵɵtext(7, "\n    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(8, "\n    ");
        ɵngcc0.ɵɵelementStart(9, "ul", 4);
        ɵngcc0.ɵɵtext(10, "\n        ");
        ɵngcc0.ɵɵelementStart(11, "div", 5);
        ɵngcc0.ɵɵtext(12, "\n            ");
        ɵngcc0.ɵɵtemplate(13, MultiselectComponent_li_13_Template, 7, 4, "li", 6);
        ɵngcc0.ɵɵtext(14, "\n        ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(15, "\n        ");
        ɵngcc0.ɵɵtemplate(16, MultiselectComponent_ng_container_16_Template, 14, 0, "ng-container", 7);
        ɵngcc0.ɵɵtext(17, "\n    ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(18, "\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(19, "\n");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("autoClose", ctx.autoClose);
        ɵngcc0.ɵɵattribute("disabled", ctx.disabled ? ctx.disabled : null);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("btn-transparent", ctx.filterMode)("btn-primary-inverse", !ctx.filterMode);
        ɵngcc0.ɵɵproperty("tabindex", ctx.disabled ? -1 : 0)("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("innerHtml", ctx.selectedItemsText(), ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(9);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.items);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showSelectAllButtons);
    } }, directives: [ɵngcc1.NgbDropdown, ɵngcc1.NgbDropdownToggle, ɵngcc1.NgbDropdownMenu, ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc2.NgClass], styles: [".show.dropdown[_ngcontent-%COMP%]{display:inline!important}.dropdown-menu[_ngcontent-%COMP%]{bottom:auto;margin-bottom:0}.dropdown-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{cursor:pointer}.select-all-separator[_ngcontent-%COMP%]{margin-bottom:2px;margin-top:2px}.select-all-button[_ngcontent-%COMP%]{color:grey;font-style:italic;margin-left:5px;margin-right:5px}.scrollable-menu[_ngcontent-%COMP%]{max-height:340px;overflow-y:auto}.scrollable-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{clear:both;color:#333;display:block;font-weight:400;line-height:1.4;padding:3px 20px;white-space:nowrap}.scrollable-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:focus, .scrollable-menu[_ngcontent-%COMP%] > li[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]:hover{background-color:#f5f5f5;color:#262626;text-decoration:none}"] });
MultiselectComponent.ctorParameters = () => [];
MultiselectComponent.propDecorators = {
    items: [{ type: Input }],
    valueIdAccessor: [{ type: Input }],
    placeholder: [{ type: Input }],
    entity: [{ type: Input }],
    showSelectAllButtons: [{ type: Input }],
    filterMode: [{ type: Input }],
    maxToShowInSelectedText: [{ type: Input }],
    disabled: [{ type: Input }],
    autoClose: [{ type: Input }],
    blur: [{ type: Output }],
    focus: [{ type: Output }],
    selectionChanged: [{ type: Output, args: ['onSelectionChanged',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MultiselectComponent, [{
        type: Component,
        args: [{
                providers: [
                    {
                        multi: true,
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => MultiselectComponent)
                    },
                ],
                selector: 'multiselect',
                template: "<span ngbDropdown class=\"dropdown\" (openChange)=\"openChange($event)\" [autoClose]=\"autoClose\" [attr.disabled]=\"disabled ? disabled : null\">\n    <button\n        ngbDropdownToggle\n        class=\"btn dropdown-toggle\"\n        type=\"button\"\n        [tabindex]=\"disabled ? -1 : 0\"\n        [class.btn-transparent]=\"filterMode\"\n        [class.btn-primary-inverse]=\"!filterMode\"\n        [disabled]=\"disabled\"\n    >\n        <span [innerHtml]=\"selectedItemsText()\"></span>\n        <span class=\"caret\"></span>\n    </button>\n    <ul ngbDropdownMenu class=\"dropdown-menu\" aria-labelledby=\"statusDropDown\">\n        <div class=\"scrollable-menu\">\n            <li *ngFor=\"let item of items; let i = index\">\n                <a (click)=\"itemSelected(i)\"> <i class=\"fa fa-fw\" [ngClass]=\"{ 'fa-check': item.Selected }\"></i>{{ getItemText(item) }} </a>\n            </li>\n        </div>\n        <ng-container *ngIf=\"showSelectAllButtons\">\n            <li class=\"select-all-separator\">\n                <a class=\"btn btn-xs btn-default btn-flat select-all-button\" (click)=\"selectAll(true)\"> select all </a>\n            </li>\n            <li>\n                <a class=\"btn btn-xs btn-default btn-flat select-all-button\" (click)=\"selectAll(false)\"> deselect all </a>\n            </li>\n        </ng-container>\n    </ul>\n</span>\n",
                styles: [".show.dropdown{display:inline!important}.dropdown-menu{bottom:auto;margin-bottom:0}.dropdown-menu>li>a{cursor:pointer}.select-all-separator{margin-bottom:2px;margin-top:2px}.select-all-button{color:grey;font-style:italic;margin-left:5px;margin-right:5px}.scrollable-menu{max-height:340px;overflow-y:auto}.scrollable-menu>li>a{clear:both;color:#333;display:block;font-weight:400;line-height:1.4;padding:3px 20px;white-space:nowrap}.scrollable-menu>li>a:focus,.scrollable-menu>li>a:hover{background-color:#f5f5f5;color:#262626;text-decoration:none}"]
            }]
    }], function () { return []; }, { valueIdAccessor: [{
            type: Input
        }], showSelectAllButtons: [{
            type: Input
        }], filterMode: [{
            type: Input
        }], disabled: [{
            type: Input
        }], blur: [{
            type: Output
        }], focus: [{
            type: Output
        }], selectionChanged: [{
            type: Output,
            args: ['onSelectionChanged']
        }], placeholder: [{
            type: Input
        }], maxToShowInSelectedText: [{
            type: Input
        }], autoClose: [{
            type: Input
        }], items: [{
            type: Input
        }], entity: [{
            type: Input
        }] }); })();

class MultiselectControlModule {
}
MultiselectControlModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MultiselectControlModule });
MultiselectControlModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function MultiselectControlModule_Factory(t) { return new (t || MultiselectControlModule)(); }, imports: [[CommonModule, FormsModule, ReactiveFormsModule, NgbModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MultiselectControlModule, { declarations: function () { return [MultiselectComponent]; }, imports: function () { return [CommonModule, FormsModule, ReactiveFormsModule, NgbModule]; }, exports: function () { return [MultiselectComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MultiselectControlModule, [{
        type: NgModule,
        args: [{
                declarations: [MultiselectComponent],
                exports: [MultiselectComponent],
                imports: [CommonModule, FormsModule, ReactiveFormsModule, NgbModule]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { MultiselectComponent, MultiselectControlModule, MultiselectItem };

//# sourceMappingURL=mt-ng2-multiselect-control.js.map